/**
 * Cart Drawer - Performance Optimized
 *
 * Performance optimizations applied:
 * 1. Cached DOM references - avoids repeated getElementById calls
 * 2. Reusable escapeHtml element - single allocation, no GC pressure per call
 * 3. Pre-defined SVG templates - avoids re-parsing SVG strings
 * 4. Debounced quantity updates - prevents API spam on rapid clicks
 * 5. DocumentFragment for batch DOM updates - single reflow
 * 6. Optimistic UI updates - immediate visual feedback
 * 7. Cached header count elements - single querySelectorAll
 * 8. srcset for retina images - proper image sizing
 */
(function() {
  'use strict';

  // ============================================================================
  // PERFORMANCE: Cache DOM references at initialization
  // ============================================================================
  var DOM = {
    drawer: document.getElementById('cart-drawer'),
    overlay: document.getElementById('cart-drawer-overlay'),
    closeBtn: document.getElementById('cart-drawer-close'),
    itemsContainer: null,
    emptyEl: null,
    footerEl: null,
    totalEl: null,
    fillEl: null,
    shippingTextEl: null
  };

  var drawer = DOM.drawer;
  var overlay = DOM.overlay;
  var closeBtn = DOM.closeBtn;

  if (!drawer || !overlay) {
    console.error('CART DRAWER OR OVERLAY NOT FOUND - SCRIPT TERMINATED');
    return;
  }

  // PERFORMANCE: Lazy-init remaining DOM refs
  function initDOMRefs() {
    if (!DOM.itemsContainer) DOM.itemsContainer = document.getElementById('cart-drawer-items');
    if (!DOM.emptyEl) DOM.emptyEl = document.getElementById('cart-drawer-empty');
    if (!DOM.footerEl) DOM.footerEl = document.getElementById('cart-drawer-footer');
    if (!DOM.totalEl) DOM.totalEl = document.getElementById('cart-drawer-total');
    if (!DOM.fillEl) DOM.fillEl = document.getElementById('cart-drawer-shipping-fill');
    if (!DOM.shippingTextEl) DOM.shippingTextEl = document.getElementById('cart-drawer-shipping-text');
  }

  // ============================================================================
  // PERFORMANCE: Pre-defined SVG templates (avoid re-parsing)
  // ============================================================================
  var SVG = {
    close: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    minus: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    plus: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    placeholder: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>',
    subscription: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/></svg>',
    freeShipping: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
    dogWeight: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 2a4 4 0 0 1 4 4c0 1.5-.8 2.8-2 3.5V12h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h4V9.5A4 4 0 0 1 12 2z"/></svg>',
    tag: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
  };

  // ============================================================================
  // PERFORMANCE: Reusable HTML escape element - single allocation
  // ============================================================================
  var escapeDiv = document.createElement('div');

  // Enable transitions after page load (prevents flash)
  requestAnimationFrame(function() {
    drawer.classList.remove('cart-drawer--no-transition');
    overlay.classList.remove('cart-drawer--no-transition');
  });

  // Initialize urgency timer (overridden when extended shipping mode is ON)
  function initUrgencyTimer() {
    const timerEl = document.getElementById('cart-drawer-urgency-timer');
    const textEl = document.getElementById('cart-drawer-urgency-text');
    const labelEl = document.getElementById('cart-drawer-urgency-label');

    if (!timerEl || !textEl || !labelEl) return;

    // Extended shipping mode override — pokazuje wspólny tekst zamiast dynamic cutoff message
    const extendedMode = ((window.PawmateCartConfig||{}).shippingExtendedMode||false);
    const extendedLabel = ((window.PawmateCartConfig||{}).shippingTimeLabel||'Wysyłka w ciągu 1–2 tygodni');

    if (extendedMode) {
      textEl.textContent = extendedLabel;
      labelEl.textContent = '';
      timerEl.textContent = '';
      const sepEl = document.querySelector('.cart-drawer__urgency-separator');
      if (sepEl) sepEl.style.display = 'none';
      return;
    }

    const now = new Date();
    const cutoff = new Date();
    cutoff.setHours(14, 0, 0, 0);

    if (now < cutoff) {
      textEl.textContent = 'Wysyłka jeszcze dziś';
      labelEl.textContent = 'zamów do';
      timerEl.textContent = '14:00';
    } else {
      textEl.textContent = 'Wysyłka jutro';
      labelEl.textContent = 'zamów do';
      timerEl.textContent = 'końca dnia';
    }
  }

  initUrgencyTimer();

  // Open drawer
  window.openCartDrawer = function() {
    // Clear inline styles that block CSS
    drawer.style.transform = '';
    drawer.style.visibility = '';
    overlay.style.opacity = '';
    overlay.style.visibility = '';

    drawer.classList.add('is-open');
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  };

  // Close drawer
  window.closeCartDrawer = function() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  };

  // Event listeners
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  overlay.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeCartDrawer();
    }
  });

  // Sub-tip close button
  var subTipCloseBtn = document.querySelector('.cart-drawer__sub-tip-close');
  if (subTipCloseBtn) {
    subTipCloseBtn.addEventListener('click', function() {
      var tip = document.getElementById('cart-drawer-sub-tip');
      if (tip) {
        tip.style.display = 'none';
        tip.classList.add('is-dismissed');
      }
    });
  }

  // Terms checkbox validation
  const termsCheckbox = document.getElementById('cart-drawer-terms-checkbox');
  const termsContainer = document.getElementById('cart-drawer-terms');
  const checkoutBtn = document.getElementById('cart-drawer-checkout-btn');
  const checkoutForm = document.getElementById('cart-drawer-form');

  if (termsCheckbox && checkoutBtn && termsContainer) {
    const TERMS_KEY = 'pawmate_terms_accepted';

    // Update button state based on checkbox
    function updateButtonState() {
      if (termsCheckbox.checked) {
        checkoutBtn.disabled = false;
        checkoutBtn.classList.remove('cart-drawer__checkout-btn--disabled');
        termsContainer.classList.remove('cart-drawer__terms--error');
      } else {
        checkoutBtn.disabled = true;
        checkoutBtn.classList.add('cart-drawer__checkout-btn--disabled');
      }
    }

    /**
     * SECURITY: Load saved state from localStorage with strict validation.
     * Only accepts exact 'true' string, rejects all other values.
     */
    function loadSavedState() {
      try {
        var saved = localStorage.getItem(TERMS_KEY);
        // SECURITY: Only accept exact 'true' string
        termsCheckbox.checked = (saved === 'true');
      } catch (e) {
        // localStorage may be blocked - fail safely
        termsCheckbox.checked = false;
      }
      updateButtonState();
    }

    /**
     * SECURITY: Save state to localStorage safely.
     * Only stores 'true' or 'false' strings, wrapped in try-catch.
     */
    function saveState() {
      try {
        localStorage.setItem(TERMS_KEY, termsCheckbox.checked ? 'true' : 'false');
      } catch (e) {
        // localStorage may be blocked or full - ignore silently
      }
    }

    // Run on load
    loadSavedState();

    // Run on pageshow (browser back/forward)
    window.addEventListener('pageshow', function() {
      loadSavedState();
    });

    // Handle checkbox change - save and update
    termsCheckbox.addEventListener('change', function() {
      saveState();
      updateButtonState();
    });

    // Sync with other tabs/components via storage event
    window.addEventListener('storage', function(e) {
      if (e.key === TERMS_KEY) {
        termsCheckbox.checked = e.newValue === 'true';
        updateButtonState();
      }
    });

    // Handle click on disabled button - show error
    // Use wrapper div because disabled buttons don't fire click events reliably
    const checkoutWrapper = document.getElementById('cart-drawer-checkout-wrapper');
    if (checkoutWrapper) {
      checkoutWrapper.addEventListener('click', function(e) {
        if (checkoutBtn.disabled || checkoutBtn.classList.contains('cart-drawer__checkout-btn--disabled')) {
          e.preventDefault();
          e.stopPropagation();
          termsContainer.classList.remove('cart-drawer__terms--error');
          // Force reflow to restart animation
          void termsContainer.offsetWidth;
          termsContainer.classList.add('cart-drawer__terms--error');

          // Scroll to checkbox if not visible
          termsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    // Handle form submission - validate terms + clear discount session
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', async function(e) {
        // First check terms checkbox
        if (!termsCheckbox.checked) {
          e.preventDefault();
          termsContainer.classList.remove('cart-drawer__terms--error');
          void termsContainer.offsetWidth;
          termsContainer.classList.add('cart-drawer__terms--error');
          return;
        }

        // Check for saved discount code in cookie
        var COOKIE_NAME = 'pawmate_discount';
        var savedCode = null;
        try {
          var nameEQ = COOKIE_NAME + '=';
          var cookies = document.cookie.split(';');
          for (var i = 0; i < cookies.length; i++) {
            var c = cookies[i].trim();
            if (c.indexOf(nameEQ) === 0) {
              savedCode = decodeURIComponent(c.substring(nameEQ.length));
              break;
            }
          }
        } catch (err) {}

        // If we have a discount code, clear session and redirect with URL param
        if (savedCode) {
          e.preventDefault();

          // 1. CLEAR any existing Shopify discount session first
          // This ensures X button in checkout will work properly
          try {
            await fetch('/discount/PAWMATE_CLEAR_SESSION', {
              method: 'GET',
              credentials: 'same-origin'
            });
          } catch (err) {
            // Ignore errors, continue to checkout
          }

          // 2. Small delay to ensure session is cleared
          await new Promise(function(r) { setTimeout(r, 100); });

          // 3. Redirect to checkout with discount in URL (native Shopify way)
          window.location.href = '/checkout?discount=' + encodeURIComponent(savedCode);
        }
        // If no discount code, let the form submit normally
      });
    }
  }

  /**
   * Show error notification to user
   * @param {string} message - The error message to display
   */
  function showErrorNotification(message) {
    const notification = document.createElement('div');
    notification.className = 'cart-drawer__error-notification';
    notification.textContent = message;
    notification.style.cssText = 'position: fixed; top: 20px; left: 50%; transform: translateX(-50%); background: #DC2626; color: white; padding: 12px 24px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); z-index: 100000; font-size: 14px; font-weight: 600;';
    document.body.appendChild(notification);

    setTimeout(function() {
      notification.style.opacity = '0';
      notification.style.transition = 'opacity 0.3s ease';
      setTimeout(function() {
        if (notification.parentNode) {
          document.body.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }


  // PERFORMANCE: Single delegated event handler with optimistic UI updates
  drawer.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;

    var action = btn.dataset.action;
    var line = parseInt(btn.dataset.line, 10);

    if (action === 'remove') {
      var item = btn.closest('.cart-drawer__item');
      var groupedKeys = item && item.dataset.groupedKeys;

      // For grouped one-time items, remove all items with those keys
      if (groupedKeys && groupedKeys.includes(',')) {
        removeGroupedItems(groupedKeys.split(','));
      } else {
        updateCartItem(line, 0);
      }
    } else if (action === 'decrease' || action === 'increase') {
      var item = btn.closest('.cart-drawer__item');
      var qtyEl = item.querySelector('.cart-drawer__qty-input');
      var bundleSize = parseInt(item.dataset.bundleSize, 10) || 1;

      // Check if this is a grouped one-time item
      var isGrouped = item.classList.contains('cart-drawer__item--grouped');
      var groupedQty = parseInt(item.dataset.groupedQty, 10) || 0;

      // Displayed qty = liczba pakietów
      var displayedQty = parseInt(qtyEl.value, 10) || 1;
      var oldDisplayedQty = displayedQty;

      // Maximum 50 items per product
      var maxQty = Math.floor(50 / bundleSize);

      if (action === 'decrease' && displayedQty > 1) {
        displayedQty -= 1;
      } else if (action === 'increase') {
        if (displayedQty >= maxQty) {
          showErrorNotification('Maksymalna ilość tego produktu to 50 sztuk.');
          return;
        }
        displayedQty += 1;
      }

      // Aktualizuj licznik
      qtyEl.value = displayedQty;

      // OPTIMISTIC UI: Aktualizuj ceny natychmiast
      var pricesEl = item.querySelector('.cart-drawer__sub-prices');
      if (pricesEl) {
        try {
          // Pobierz cenę jednostkową z data atrybutu (w groszach) - to jest cena JEDNEJ SUBSKRYPCJI
          var unitPriceCents = parseInt(item.dataset.unitPrice, 10);
          var frequency = item.dataset.frequency || '';

          if (unitPriceCents && unitPriceCents > 0) {
            // Oblicz nową cenę łączną (w groszach) - displayedQty to liczba subskrypcji
            var newTotalCents = unitPriceCents * displayedQty;

            // Formatuj ceny (grosze -> złotówki)
            var unitPriceFormatted = (unitPriceCents / 100).toFixed(2).replace('.', ',');
            var newTotalFormatted = (newTotalCents / 100).toFixed(2).replace('.', ',');

            // Dodaj "/" przed częstotliwością jeśli jest
            var freqSuffix = frequency ? '/' + frequency : '';

            // Zbuduj nowy HTML - displayedQty to liczba subskrypcji (nie butelek!)
            var newInnerHTML = displayedQty + ' x ' + unitPriceFormatted + ' zł ' +
              '<span class="cart-drawer__dot">•</span> ' +
              '<strong>' + newTotalFormatted + ' zł' + freqSuffix + '</strong>';

            pricesEl.innerHTML = newInnerHTML;
          }
        } catch (e) {
          console.error('OPTIMISTIC ERROR:', e);
        }
      }

      // Aktualizuj też tekst "X sztuki co..."
      var variantLineEl = item.querySelector('.cart-drawer__item-variant-line');
      if (variantLineEl) {
        var variantText = variantLineEl.textContent;
        var newActualQty = displayedQty * bundleSize;
        variantLineEl.textContent = variantText.replace(/^\d+\s*(sztuka|sztuki|sztuk)/, newActualQty + ' ' + formatSztuki(newActualQty));
      }

      // Aktualizuj subscription-plan jeśli zawiera "×"
      var planEl = item.querySelector('.cart-drawer__subscription-plan');
      if (planEl) {
        var currentText = planEl.textContent;
        if (currentText.includes('×')) {
          var packageName = currentText.split('×')[1].trim();
          planEl.textContent = displayedQty + '× ' + packageName;
        }
      }

      // OPTIMISTIC UI: Aktualizuj cenę łączną koszyka
      updateCartTotalOptimistic();

      // For grouped items: only change the FIRST line by the DELTA (+1 or -1)
      // NOT setting total quantity on one line (which would leave other lines untouched)
      if (isGrouped && groupedQty > 0) {
        // Get the current qty of the first line from the API (we need to fetch cart first)
        // For simplicity, we calculate delta and apply to first line
        var delta = action === 'increase' ? 1 : -1;
        // We need to know the current qty of line to add/subtract from it
        // Fetch current cart state and update
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var lineItem = cart.items[line - 1];
            if (lineItem) {
              var newLineQty = Math.max(0, lineItem.quantity + delta);
              updateCartItem(line, newLineQty);
            }
          })
          .catch(function(err) {
            console.error('Failed to get cart for grouped update:', err);
            // Fallback: just refresh
            refreshDrawerContent();
          });
      } else {
        // API dostaje prawdziwą ilość butelek
        var actualQty = displayedQty * bundleSize;
        updateCartItem(line, actualQty);
      }
    }
  });

  // Event listener dla bezpośredniej zmiany ilości w inpucie
  drawer.addEventListener('change', function(e) {
    var input = e.target;
    if (!input.classList.contains('cart-drawer__qty-input')) return;

    var item = input.closest('.cart-drawer__item');
    var line = parseInt(input.dataset.line, 10);
    var bundleSize = parseInt(item.dataset.bundleSize, 10) || 1;
    var newQty = parseInt(input.value, 10);
    if (isNaN(newQty)) newQty = 1;

    // If 0, remove the item
    if (newQty === 0) {
      updateCartItem(line, 0);
      return;
    }

    // Minimum 1 (for any other invalid value)
    if (newQty < 1) {
      newQty = 1;
      input.value = 1;
    }

    // Maximum 50 (per product limit)
    var maxQty = Math.floor(50 / bundleSize);
    if (newQty > maxQty) {
      newQty = maxQty;
      input.value = maxQty;
      showErrorNotification('Maksymalna ilość tego produktu to 50 sztuk.');
    }

    // OPTIMISTIC UI: Aktualizuj ceny natychmiast
    var pricesEl = item.querySelector('.cart-drawer__sub-prices');
    if (pricesEl) {
      try {
        var unitPriceCents = parseInt(item.dataset.unitPrice, 10);
        var frequency = item.dataset.frequency || '';

        if (unitPriceCents && unitPriceCents > 0) {
          var newTotalCents = unitPriceCents * newQty;
          var unitPriceFormatted = (unitPriceCents / 100).toFixed(2).replace('.', ',');
          var newTotalFormatted = (newTotalCents / 100).toFixed(2).replace('.', ',');
          var freqSuffix = frequency ? '/' + frequency : '';

          var newInnerHTML = newQty + ' x ' + unitPriceFormatted + ' zł ' +
            '<span class="cart-drawer__dot">•</span> ' +
            '<strong>' + newTotalFormatted + ' zł' + freqSuffix + '</strong>';

          pricesEl.innerHTML = newInnerHTML;
        }
      } catch (err) {
        console.error('INPUT CHANGE ERROR:', err);
      }
    }

    // Aktualizuj tekst "X sztuki co..."
    var variantLineEl = item.querySelector('.cart-drawer__item-variant-line');
    if (variantLineEl) {
      var variantText = variantLineEl.textContent;
      var newActualQty = newQty * bundleSize;
      variantLineEl.textContent = variantText.replace(/^\d+\s*(sztuka|sztuki|sztuk)/, newActualQty + ' ' + formatSztuki(newActualQty));
    }

    // Aktualizuj subscription-plan jeśli zawiera "×"
    var planEl = item.querySelector('.cart-drawer__subscription-plan');
    if (planEl) {
      var currentText = planEl.textContent;
      if (currentText.includes('×')) {
        var packageName = currentText.split('×')[1].trim();
        planEl.textContent = newQty + '× ' + packageName;
      }
    }

    // OPTIMISTIC UI: Aktualizuj cenę łączną koszyka
    updateCartTotalOptimistic();

    // Check if this is a grouped one-time item
    var isGrouped = item.classList.contains('cart-drawer__item--grouped');
    var groupedQty = parseInt(item.dataset.groupedQty, 10) || 0;

    if (isGrouped && groupedQty > 0) {
      // For grouped items: calculate delta and apply to first line only
      var delta = newQty - groupedQty;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var lineItem = cart.items[line - 1];
          if (lineItem) {
            var newLineQty = Math.max(0, lineItem.quantity + delta);
            updateCartItem(line, newLineQty);
          }
        })
        .catch(function(err) {
          console.error('Failed to get cart for grouped input change:', err);
          refreshDrawerContent();
        });
    } else {
      // API dostaje prawdziwą ilość butelek
      var actualQty = newQty * bundleSize;
      updateCartItem(line, actualQty);
    }
  });

  // Funkcja do optymistycznej aktualizacji sumy koszyka
  function updateCartTotalOptimistic() {
    var items = document.querySelectorAll('.cart-drawer__item');
    var onetimeTotal = 0;
    var subscriptionTotal = 0;
    var frequencyTotals = {};

    items.forEach(function(item) {
      var isSubscription = item.classList.contains('cart-drawer__item--subscription');
      var pricesEl = item.querySelector('.cart-drawer__sub-prices');

      if (pricesEl) {
        var strongMatch = pricesEl.innerHTML.match(/<strong>([^<]*)<\/strong>/);
        if (strongMatch) {
          var priceText = strongMatch[1];
          var priceOnly = priceText.split('/')[0].trim();
          var priceMatch = priceOnly.match(/([\d\s,]+)\s*zł/);
          if (priceMatch) {
            var price = parseFloat(priceMatch[1].replace(/\s/g, '').replace(',', '.'));
            var priceCents = Math.round(price * 100);

            if (isSubscription) {
              subscriptionTotal += priceCents;
              var freq = item.dataset.frequency || 'mies.';
              if (!frequencyTotals[freq]) {
                frequencyTotals[freq] = 0;
              }
              frequencyTotals[freq] += priceCents;
            } else {
              onetimeTotal += priceCents;
            }
          }
        }
      }
    });

    var frequencies = Object.keys(frequencyTotals);
    var hasSubscriptions = subscriptionTotal > 0;
    var total = subscriptionTotal + onetimeTotal;

    // Update totals display - simple design with hover tooltip
    var totalsContainer = document.getElementById('cart-drawer-totals-container') || document.querySelector('.cart-drawer__totals');
    if (totalsContainer && total > 0) {
      var newTotalsHTML = '';
      var freqCount = frequencies.length;
      var singleFrequency = freqCount === 1 ? frequencies[0] : '';
      var onlySubscriptions = hasSubscriptions && onetimeTotal === 0;
      var hasMixed = hasSubscriptions && onetimeTotal > 0;

      // Main total row
      newTotalsHTML += '<div class="cart-drawer__subtotal"><span>Razem</span>';

      if (onlySubscriptions) {
        if (freqCount === 1) {
          // Single frequency - show price / x mies.
          newTotalsHTML += '<span class="cart-drawer__subtotal-value" id="cart-drawer-total">' + formatMoney(total) + ' <span class="cart-drawer__subtotal-freq">/ ' + singleFrequency + '</span></span>';
        } else {
          // Multiple frequencies - show price cyklicznie with icon
          newTotalsHTML += '<span class="cart-drawer__subtotal-value cart-drawer__subtotal-value--recurring" id="cart-drawer-total">' +
            formatMoney(total) + ' <span class="cart-drawer__subtotal-cyclic">cyklicznie</span>' +
            '<svg class="cart-drawer__recurring-icon" width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><path d="M8 0a8 8 0 1 0 8 8A8 8 0 0 0 8 0zm0 14.5A6.5 6.5 0 1 1 14.5 8 6.51 6.51 0 0 1 8 14.5zM8 6a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 8 6zm0-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1z"/></svg>' +
            '<div class="cart-drawer__recurring-tooltip cart-drawer__recurring-tooltip--inline">';

          // Tooltip: subscription rows by frequency
          frequencies.forEach(function(freq) {
            newTotalsHTML += '<div class="cart-drawer__tooltip-row cart-drawer__tooltip-row--subscription" data-frequency="' + freq + '">' +
              '<span>Co ' + freq + '</span>' +
              '<span>' + formatMoney(frequencyTotals[freq]) + '</span>' +
            '</div>';
          });

          newTotalsHTML += '</div></span>';
        }
      } else {
        // Mixed or only one-time
        newTotalsHTML += '<span class="cart-drawer__subtotal-value" id="cart-drawer-total">' + formatMoney(total) + '</span>';
      }

      newTotalsHTML += '</div>';

      // Recurring hint with tooltip (only if mixed - has both onetime and subscriptions)
      if (hasMixed) {
        newTotalsHTML += '<div class="cart-drawer__recurring-hint" id="cart-drawer-recurring-hint">' +
          '<span class="cart-drawer__recurring-text">' +
            'w tym <strong id="cart-drawer-subscription-total">' + formatMoney(subscriptionTotal) + '</strong> cyklicznie ' +
            '<svg class="cart-drawer__recurring-icon" width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><path d="M8 0a8 8 0 1 0 8 8A8 8 0 0 0 8 0zm0 14.5A6.5 6.5 0 1 1 14.5 8 6.51 6.51 0 0 1 8 14.5zM8 6a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 8 6zm0-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1z"/></svg>' +
          '</span>' +
          '<div class="cart-drawer__recurring-tooltip" id="cart-drawer-tooltip">';

        // Tooltip: one-time row
        newTotalsHTML += '<div class="cart-drawer__tooltip-row">' +
          '<span>Jednorazowo</span>' +
          '<span id="cart-drawer-tooltip-onetime">' + formatMoney(onetimeTotal) + '</span>' +
        '</div>';

        // Tooltip: subscription rows by frequency
        frequencies.forEach(function(freq) {
          newTotalsHTML += '<div class="cart-drawer__tooltip-row cart-drawer__tooltip-row--subscription" data-frequency="' + freq + '">' +
            '<span>Co ' + freq + '</span>' +
            '<span>' + formatMoney(frequencyTotals[freq]) + '</span>' +
          '</div>';
        });

        newTotalsHTML += '</div></div>'; // Close tooltip and hint
      }

      newTotalsHTML += '<p class="cart-drawer__taxes-note">Koszty dostawy obliczane przy finalizacji</p>';

      totalsContainer.innerHTML = newTotalsHTML;
    }

    // Update shipping progress
    updateShippingProgressOptimistic(total);
  }

  // Funkcja do optymistycznej aktualizacji paska wysyłki
  function updateShippingProgressOptimistic(totalCents) {
    var threshold = 4900; // 49 zł w groszach
    var remaining = Math.max(0, threshold - totalCents);
    var progressPercent = Math.min(100, (totalCents / threshold) * 100);

    var fillEl = document.getElementById('cart-drawer-shipping-fill');
    var textEl = document.getElementById('cart-drawer-shipping-text');

    if (fillEl) {
      fillEl.style.width = progressPercent + '%';
      fillEl.classList.toggle('cart-drawer__shipping-fill--success', remaining <= 0);
    }

    if (textEl) {
      if (remaining <= 0) {
        textEl.innerHTML = SVG.freeShipping + '<strong>Masz darmową wysyłkę!</strong>';
      } else {
        var remainingFormatted = (remaining / 100).toFixed(2).replace('.', ',') + ' zł';
        textEl.innerHTML = 'Brakuje <strong id="cart-drawer-remaining">' + remainingFormatted + '</strong> do darmowej wysyłki';
      }
    }
  }

  // Debounce timer for cart updates to prevent race conditions
  let updateCartDebounceTimer = null;
  const pendingCartUpdates = new Map();

  /**
   * Remove multiple grouped items by their keys
   * @param {Array} keys - Array of cart item keys to remove
   */
  function removeGroupedItems(keys) {
    drawer.classList.add('cart-drawer--loading');

    // Build updates object with all keys set to 0
    var updates = {};
    keys.forEach(function(key) {
      updates[key.trim()] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Failed to remove items');
      }
      return response.json();
    })
    .then(function() {
      refreshDrawerContent();
      drawer.classList.remove('cart-drawer--loading');
    })
    .catch(function(err) {
      console.error('Remove grouped items error:', err);
      showErrorNotification('Nie udało się usunąć produktów z koszyka.');
      drawer.classList.remove('cart-drawer--loading');
    });
  }

  /**
   * Update cart item via AJAX with debouncing and error handling
   * @param {number} line - The line item number in the cart
   * @param {number} quantity - The new quantity for the item
   */
  function updateCartItem(line, quantity) {
    // Store the latest update request
    pendingCartUpdates.set(line, quantity);

    // Clear existing timer
    if (updateCartDebounceTimer) {
      clearTimeout(updateCartDebounceTimer);
    }

    drawer.classList.add('cart-drawer--loading');

    // Debounce multiple rapid updates (300ms delay)
    updateCartDebounceTimer = setTimeout(function() {
      // Process all pending updates sequentially to avoid race conditions
      const updates = Array.from(pendingCartUpdates.entries());
      pendingCartUpdates.clear();

      // Process updates one by one in sequence
      processCartUpdates(updates, 0);
    }, 300);
  }

  /**
   * Process cart updates sequentially to prevent race conditions
   * @param {Array} updates - Array of [line, quantity] tuples
   * @param {number} index - Current index in the updates array
   */
  function processCartUpdates(updates, index) {
    if (index >= updates.length) {
      // All updates complete, refresh drawer
      refreshDrawerContent();
      drawer.classList.remove('cart-drawer--loading');
      return;
    }

    const [line, quantity] = updates[index];

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) {
          // Shopify returns error details in JSON
          var errorMessage = 'Nie udało się zaktualizować koszyka.';

          if (data.description || data.message) {
            var shopifyMsg = (data.description || data.message || '').toLowerCase();
            // Check for quantity/availability limit errors - catch all variations
            if (shopifyMsg.includes('50') ||
                shopifyMsg.includes('quantity') ||
                shopifyMsg.includes('limit') ||
                shopifyMsg.includes('tylko') ||
                shopifyMsg.includes('pozycj') ||
                shopifyMsg.includes('dodane') ||
                shopifyMsg.includes('dostępn') ||
                shopifyMsg.includes('dostepn') ||
                shopifyMsg.includes('available') ||
                shopifyMsg.includes('stock') ||
                shopifyMsg.includes('inventory')) {
              errorMessage = 'Maksymalna ilość tego produktu to 50 sztuk.';
            } else {
              // Don't show raw Shopify message, use our generic error
              errorMessage = 'Nie udało się zaktualizować koszyka.';
            }
          }

          throw new Error(errorMessage);
        }
        return data;
      });
    })
    .then(function(cart) {
      updateCartCount(calculateCartCount(cart));

      // Check for partial success messages (Shopify caps quantity silently)
      // Don't show the default "only X added due to availability" message
      if (cart.message && (
        cart.message.toLowerCase().includes('dostępn') ||
        cart.message.toLowerCase().includes('pozycj') ||
        cart.message.toLowerCase().includes('available') ||
        cart.message.toLowerCase().includes('added')
      )) {
        // Show our custom message instead
        showErrorNotification('Maksymalna ilość tego produktu to 50 sztuk.');
        refreshDrawerContent();
      }

      // Process next update
      processCartUpdates(updates, index + 1);
    })
    .catch(function(error) {
      console.error('Cart update error:', error);
      showErrorNotification(error.message || 'Nie udało się zaktualizować koszyka. Spróbuj ponownie.');
      // Refresh cart to show correct quantities
      refreshDrawerContent();
      drawer.classList.remove('cart-drawer--loading');
    });
  }

  // ============================================================================
  // Helper: build line-level discount badges HTML
  // ============================================================================
  function buildDiscountsHtml(item) {
    // UKRYTE - zniżki w koszyku
    return '';
    /*
    if (!item.line_level_discount_allocations || item.line_level_discount_allocations.length === 0) return '';
    var html = '<div class="cart-drawer__discounts">';
    item.line_level_discount_allocations.forEach(function(alloc) {
      html += '<span class="cart-drawer__discount-badge">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
        escapeHtml(alloc.title) + ': -' + formatMoney(alloc.amount) +
      '</span>';
    });
    html += '</div>';
    return html;
    */
  }

  // ============================================================================
  // PERFORMANCE: Helper to create cart item element (for DocumentFragment)
  // ============================================================================
  function createItemElement(item, index) {
    var isSubscription = !!item.selling_plan_allocation;
    var planName = isSubscription ? item.selling_plan_allocation.selling_plan.name : '';
    var lineIndex = index + 1;
    var escapedTitle = escapeHtml(item.product_title);
    var escapedItemUrl = escapeUrl(item.url);

    var div = document.createElement('div');
    div.className = 'cart-drawer__item' + (isSubscription ? ' cart-drawer__item--subscription' : '');
    div.setAttribute('data-line', lineIndex);
    div.setAttribute('data-variant-id', item.variant_id);

    // Bundle Size for cart drawer +/- logic
    // For subscriptions: use Bundle Size property or fallback to 1
    // For regular products: always 1
    // NEVER use item.quantity as fallback - it grows with qty causing multiplication bug
    var bundleSize = (isSubscription && item.properties && item.properties['_Bundle Size'])
      ? parseInt(item.properties['_Bundle Size'])
      : 1;
    div.setAttribute('data-bundle-size', bundleSize);

    // Unit price in cents for optimistic UI updates
    var subQty = isSubscription ? Math.max(1, Math.floor(item.quantity / bundleSize)) : item.quantity;
    var unitPrice = Math.round(item.final_line_price / subQty);
    div.setAttribute('data-unit-price', unitPrice);

    // PERFORMANCE: srcset for retina displays
    var imageHtml;
    if (item.image) {
      // All items use 68x68 images for consistent layout
      var imgSize = '136x';
      var imgSize2x = '272x';
      var imgWidth = 68;
      var imgHeight = 68;

      var src1x = getSizedImageUrl(item.image, imgSize);
      var src2x = getSizedImageUrl(item.image, imgSize2x);
      imageHtml = '<img src="' + src1x + '" srcset="' + src1x + ' 1x, ' + src2x + ' 2x" alt="' + escapeHtml(item.title) + '" class="cart-drawer__item-image" width="' + imgWidth + '" height="' + imgHeight + '" loading="lazy" decoding="async">';
    } else {
      imageHtml = '<div class="cart-drawer__item-image-placeholder">' + SVG.placeholder + '</div>';
    }

    if (isSubscription) {
      var dogWeight = (item.properties && item.properties['Waga psa']) ? item.properties['Waga psa'] : '';
      var subQty = Math.max(1, Math.floor(item.quantity / bundleSize));
      var humanReadableFrequency = planName.replace('Zapas na ', '').split(' (')[0];
      var shortFrequency = humanReadableFrequency.replace('miesiące', 'mies.').replace('miesiąc', 'mies.').replace('miesięcy', 'mies.');

      // Set frequency data attribute for optimistic UI updates
      div.setAttribute('data-frequency', shortFrequency);

      // Title row with badge and weight on the left of product name
      var badgeRowHtml = '<div class="cart-drawer__badge-row">' +
        '<span class="cart-drawer__subscription-badge">Subskrypcja</span>' +
        (dogWeight ? '<span class="cart-drawer__weight-label">' + escapeHtml(dogWeight) + '</span>' : '') +
      '</div>';

      var titleRowHtml = '<div class="cart-drawer__item-title-row">' +
        badgeRowHtml +
        '<a href="' + escapedItemUrl + '" class="cart-drawer__item-title">' + escapedTitle + '</a>' +
      '</div>';

      // Variant line with frequency only (weight moved to badge row)
      var variantLineHtml = '<span class="cart-drawer__item-variant-line">' +
        item.quantity + ' ' + formatSztuki(item.quantity) + ' co ' + humanReadableFrequency +
      '</span>';

      // Details line and prices (combined into one row)
      var unitPriceSub = Math.round(item.final_line_price / subQty);
      var totalPriceHtml = formatMoney(item.final_line_price);

      // UKRYTE - zniżki w koszyku
      var discountBadgeHtml = '';
      /*
      // Calculate subscription discount: base_price - final_price
      var basePricePerBottle = ((window.PawmateCartConfig||{}).dogPriceCents||14999); // groszy - z Shopify product
      var subOriginalPrice = bundleSize * basePricePerBottle * subQty;
      var subDiscount = subOriginalPrice - item.final_line_price;
      if (subDiscount > 0) {
        discountBadgeHtml = '<div class="cart-drawer__discounts">' +
          '<span class="cart-drawer__discount-badge cart-drawer__discount-badge--subscription">' +
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
            'Rabat subskrypcji: -' + formatMoney(subDiscount) +
          '</span>' +
        '</div>';
      }
      */

      // Quantity controls (moved to bottom of right column, after prices)
      var quantityControlsHtml = '<div class="cart-drawer__item-quantity cart-drawer__item-quantity--subscription">' +
          '<button type="button" class="cart-drawer__qty-btn" data-action="decrease" data-line="' + lineIndex + '" aria-label="Zmniejsz ilosc subskrypcji ' + escapedTitle + '"' + (item.quantity <= bundleSize ? ' disabled' : '') + '>' + SVG.minus + '</button>' +
          '<input type="text" inputmode="numeric" pattern="[0-9]*" class="cart-drawer__qty-input" data-bundle-size="' + bundleSize + '" data-line="' + lineIndex + '" value="' + subQty + '" min="1" aria-label="Ilosc">' +
          '<button type="button" class="cart-drawer__qty-btn" data-action="increase" data-line="' + lineIndex + '" aria-label="Zwieksz ilosc subskrypcji ' + escapedTitle + '">' + SVG.plus + '</button>' +
        '</div>';

      // Line-level discounts (inline with prices)
      var discountsHtmlSub = buildDiscountsHtml(item);

      // New structure: left column (image only), right (info + prices + qty controls)
      div.innerHTML =
        '<div class="cart-drawer__item-left">' +
          '<a href="' + escapedItemUrl + '" class="cart-drawer__item-image-link">' + imageHtml + '</a>' +
        '</div>' +
        '<div class="cart-drawer__item-info">' +
          titleRowHtml +
          variantLineHtml +
          '<div class="cart-drawer__sub-row">' +
            '<div class="cart-drawer__sub-left">' +
              '<span class="cart-drawer__sub-prices">' + subQty + ' x ' + formatMoney(unitPriceSub) + ' <span class="cart-drawer__dot">•</span> <strong>' + totalPriceHtml + '/' + shortFrequency + '</strong></span>' +
              discountBadgeHtml +
              discountsHtmlSub +
            '</div>' +
            quantityControlsHtml +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-drawer__item-remove" data-action="remove" data-line="' + lineIndex + '" aria-label="Usun ' + escapedTitle + '">' + SVG.close + '</button>';
    } else {
      // Regular product - matching subscription layout style
      var regularUnitPrice = Math.round(item.final_line_price / item.quantity);
      var variantText = item.quantity + ' ' + formatSztuki(item.quantity);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantText += ' • ' + escapeHtml(item.variant_title);
      }
      var variantLineHtml = '<span class="cart-drawer__item-variant-line">' + variantText + '</span>';

      var titleRowHtml = '<div class="cart-drawer__item-title-row">' +
        '<span class="cart-drawer__onetime-badge">Produkt</span>' +
        '<a href="' + escapedItemUrl + '" class="cart-drawer__item-title">' + escapedTitle + '</a>' +
      '</div>';

      // Line-level discounts (inline with prices)
      var discountsHtmlReg = buildDiscountsHtml(item);

      div.innerHTML =
        '<div class="cart-drawer__item-left">' +
          '<a href="' + escapedItemUrl + '" class="cart-drawer__item-image-link">' + imageHtml + '</a>' +
        '</div>' +
        '<div class="cart-drawer__item-info">' +
          titleRowHtml +
          variantLineHtml +
          '<div class="cart-drawer__sub-row">' +
            '<div class="cart-drawer__sub-left">' +
              '<span class="cart-drawer__sub-prices">' + item.quantity + ' x ' + formatMoney(regularUnitPrice) + ' <span class="cart-drawer__dot">•</span> <strong>' + formatMoney(item.final_line_price) + '</strong></span>' +
              discountsHtmlReg +
            '</div>' +
            '<div class="cart-drawer__item-quantity">' +
              '<button type="button" class="cart-drawer__qty-btn" data-action="decrease" data-line="' + lineIndex + '" aria-label="Zmniejsz ilosc ' + escapedTitle + '"' + (item.quantity <= 1 ? ' disabled' : '') + '>' + SVG.minus + '</button>' +
              '<input type="text" inputmode="numeric" pattern="[0-9]*" class="cart-drawer__qty-input" data-line="' + lineIndex + '" value="' + item.quantity + '" min="1" aria-label="Ilosc">' +
              '<button type="button" class="cart-drawer__qty-btn" data-action="increase" data-line="' + lineIndex + '" aria-label="Zwieksz ilosc ' + escapedTitle + '">' + SVG.plus + '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-drawer__item-remove" data-action="remove" data-line="' + lineIndex + '" aria-label="Usun ' + escapedTitle + '">' + SVG.close + '</button>';
    }

    return div;
  }

  // ============================================================================
  // Create grouped one-time item element (multiple line items with same variant)
  // ============================================================================
  function createGroupedItemElement(group) {
    var item = group.item;
    var lineIndex = group.index + 1;
    var escapedTitle = escapeHtml(item.product_title);
    var escapedItemUrl = escapeUrl(item.url);

    var div = document.createElement('div');
    div.className = 'cart-drawer__item cart-drawer__item--grouped';
    div.setAttribute('data-line', lineIndex);
    div.setAttribute('data-variant-id', item.variant_id);
    div.setAttribute('data-bundle-size', '1');
    div.setAttribute('data-key', item.key);
    div.setAttribute('data-grouped-lines', group.lineIndices.join(','));
    div.setAttribute('data-grouped-keys', group.keys.join(','));
    div.setAttribute('data-grouped-qty', group.quantity);

    var unitPrice = Math.round(group.price / group.quantity);
    div.setAttribute('data-unit-price', unitPrice);

    // Image HTML
    var imageHtml;
    if (item.image) {
      var src1x = getSizedImageUrl(item.image, '136x');
      var src2x = getSizedImageUrl(item.image, '272x');
      imageHtml = '<img src="' + src1x + '" srcset="' + src1x + ' 1x, ' + src2x + ' 2x" alt="' + escapeHtml(item.title) + '" class="cart-drawer__item-image" width="68" height="68" loading="lazy" decoding="async">';
    } else {
      imageHtml = '<div class="cart-drawer__item-image-placeholder">' + SVG.placeholder + '</div>';
    }

    // Variant text
    var variantText = group.quantity + ' ' + formatSztuki(group.quantity);
    if (item.variant_title && item.variant_title !== 'Default Title') {
      variantText += ' • ' + escapeHtml(item.variant_title);
    }
    var variantLineHtml = '<span class="cart-drawer__item-variant-line">' + variantText + '</span>';

    var titleRowHtml = '<div class="cart-drawer__item-title-row">' +
      '<span class="cart-drawer__onetime-badge">Produkt</span>' +
      '<a href="' + escapedItemUrl + '" class="cart-drawer__item-title">' + escapedTitle + '</a>' +
    '</div>';

    // Build discounts HTML from grouped discounts
    // UKRYTE - zniżki w koszyku
    var discountsHtml = '';
    var unitPrice = Math.round(group.price / group.quantity);
    var pricesHtml = group.quantity + ' x ' + formatMoney(unitPrice) + ' <span class="cart-drawer__dot">•</span> <strong>' + formatMoney(group.price) + '</strong>';

    div.innerHTML =
      '<div class="cart-drawer__item-left">' +
        '<a href="' + escapedItemUrl + '" class="cart-drawer__item-image-link">' + imageHtml + '</a>' +
      '</div>' +
      '<div class="cart-drawer__item-info">' +
        titleRowHtml +
        variantLineHtml +
        '<div class="cart-drawer__sub-row">' +
          '<div class="cart-drawer__sub-left">' +
            '<span class="cart-drawer__sub-prices">' + pricesHtml + '</span>' +
            discountsHtml +
          '</div>' +
          '<div class="cart-drawer__item-quantity">' +
            '<button type="button" class="cart-drawer__qty-btn" data-action="decrease" data-line="' + lineIndex + '" aria-label="Zmniejsz ilosc ' + escapedTitle + '"' + (group.quantity <= 1 ? ' disabled' : '') + '>' + SVG.minus + '</button>' +
            '<input type="text" inputmode="numeric" pattern="[0-9]*" class="cart-drawer__qty-input" data-line="' + lineIndex + '" value="' + group.quantity + '" min="1" aria-label="Ilosc">' +
            '<button type="button" class="cart-drawer__qty-btn" data-action="increase" data-line="' + lineIndex + '" aria-label="Zwieksz ilosc ' + escapedTitle + '">' + SVG.plus + '</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="cart-drawer__item-remove" data-action="remove" data-line="' + lineIndex + '" aria-label="Usun ' + escapedTitle + '">' + SVG.close + '</button>';

    return div;
  }

  // ============================================================================
  // PERFORMANCE: Optimized refresh using cached DOM refs and DocumentFragment
  // ============================================================================
  var FREE_SHIPPING_THRESHOLD = 4900; // 49 zl in cents

  function refreshDrawerContent(cartData) {
    function doRefresh(cart) {
      initDOMRefs();
      updateCartCount(calculateCartCount(cart));

      // Calculate subscription totals grouped by frequency
      var onetimeTotal = 0;
      var subscriptionTotal = 0;
      var subscriptionOriginalTotal = 0;
      var basePricePerBottle = ((window.PawmateCartConfig||{}).dogPriceCents||14999); // groszy - z Shopify product
      var frequencyTotals = {};

      cart.items.forEach(function(item) {
        if (item.selling_plan_allocation) {
          subscriptionTotal += item.final_line_price;
          var planName = item.selling_plan_allocation.selling_plan.name;
          var freq = planName.replace('Zapas na ', '').split(' (')[0].replace('miesiące', 'mies.').replace('miesiąc', 'mies.').replace('miesięcy', 'mies.');
          if (!frequencyTotals[freq]) {
            frequencyTotals[freq] = 0;
          }
          frequencyTotals[freq] += item.final_line_price;

          // Calculate original price for this subscription item
          var itemBundleSize = 1;
          if (planName.indexOf('2 butelki') !== -1) itemBundleSize = 2;
          if (planName.indexOf('3 butelki') !== -1) itemBundleSize = 3;
          var itemSubQty = Math.max(1, Math.floor(item.quantity / itemBundleSize));
          var itemOriginal = itemBundleSize * basePricePerBottle * itemSubQty;
          subscriptionOriginalTotal += itemOriginal;
        } else {
          onetimeTotal += item.final_line_price;
        }
      });

      var subscriptionDiscount = subscriptionOriginalTotal - subscriptionTotal;

      var frequencies = Object.keys(frequencyTotals);
      var hasSubscriptions = subscriptionTotal > 0;
      var freqCount = frequencies.length;
      var singleFrequency = freqCount === 1 ? frequencies[0] : '';
      var onlySubscriptions = hasSubscriptions && onetimeTotal === 0;
      var hasMixed = hasSubscriptions && onetimeTotal > 0;

      // Update totals display - simple design with hover tooltip
      var totalsContainer = document.getElementById('cart-drawer-totals-container') || document.querySelector('.cart-drawer__totals');
      if (totalsContainer) {
        var newTotalsHTML = '';

        // UKRYTE - Cart-level discounts
        /*
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
          cart.cart_level_discount_applications.forEach(function(discount) {
            newTotalsHTML += '<div class="cart-drawer__discount-row">' +
              '<span class="cart-drawer__discount-pill">' +
                '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
                escapeHtml(discount.title) +
              '</span>' +
              '<span class="cart-drawer__discount-value">-' + formatMoney(discount.total_allocated_amount) + '</span>' +
            '</div>';
          });
        }
        */

        // Main total row
        newTotalsHTML += '<div class="cart-drawer__subtotal">' +
          '<span>Razem</span>';

        // UKRYTE - strikethrough price
        var strikeHtml = '';

        if (onlySubscriptions) {
          if (freqCount === 1) {
            // Only subscriptions with single frequency - show price / x mies.
            newTotalsHTML += '<span class="cart-drawer__subtotal-value" id="cart-drawer-total">' + formatMoney(cart.total_price) + ' <span class="cart-drawer__subtotal-freq">/ ' + singleFrequency + '</span></span>';
          } else {
            // Only subscriptions with multiple frequencies - show price cyklicznie with icon and tooltip
            newTotalsHTML += '<span class="cart-drawer__subtotal-value cart-drawer__subtotal-value--recurring" id="cart-drawer-total">' +
              formatMoney(cart.total_price) + ' <span class="cart-drawer__subtotal-cyclic">cyklicznie</span>' +
              '<svg class="cart-drawer__recurring-icon" width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><path d="M8 0a8 8 0 1 0 8 8A8 8 0 0 0 8 0zm0 14.5A6.5 6.5 0 1 1 14.5 8 6.51 6.51 0 0 1 8 14.5zM8 6a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 8 6zm0-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1z"/></svg>' +
              '<div class="cart-drawer__recurring-tooltip cart-drawer__recurring-tooltip--inline">';

            // Tooltip: subscription rows by frequency
            frequencies.forEach(function(freq) {
              newTotalsHTML += '<div class="cart-drawer__tooltip-row cart-drawer__tooltip-row--subscription" data-frequency="' + freq + '">' +
                '<span>Co ' + freq + '</span>' +
                '<span>' + formatMoney(frequencyTotals[freq]) + '</span>' +
              '</div>';
            });

            newTotalsHTML += '</div></span>';
          }
        } else {
          // No subscriptions or mixed - show just price
          newTotalsHTML += '<span class="cart-drawer__subtotal-value" id="cart-drawer-total">' + formatMoney(cart.total_price) + '</span>';
        }

        newTotalsHTML += '</div>';

        // Recurring hint with tooltip (only if mixed - subs + one-time)
        if (hasMixed) {
          newTotalsHTML += '<div class="cart-drawer__recurring-hint" id="cart-drawer-recurring-hint">' +
            '<span class="cart-drawer__recurring-text">' +
              'w tym <strong id="cart-drawer-subscription-total">' + formatMoney(subscriptionTotal) + '</strong> cyklicznie ' +
              '<svg class="cart-drawer__recurring-icon" width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><path d="M8 0a8 8 0 1 0 8 8A8 8 0 0 0 8 0zm0 14.5A6.5 6.5 0 1 1 14.5 8 6.51 6.51 0 0 1 8 14.5zM8 6a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 8 6zm0-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1z"/></svg>' +
            '</span>' +
            '<div class="cart-drawer__recurring-tooltip" id="cart-drawer-tooltip">';

          // Tooltip: one-time row
          if (onetimeTotal > 0) {
            newTotalsHTML += '<div class="cart-drawer__tooltip-row">' +
              '<span>Jednorazowo</span>' +
              '<span id="cart-drawer-tooltip-onetime">' + formatMoney(onetimeTotal) + '</span>' +
            '</div>';
          }

          // Tooltip: subscription rows by frequency
          frequencies.forEach(function(freq) {
            newTotalsHTML += '<div class="cart-drawer__tooltip-row cart-drawer__tooltip-row--subscription" data-frequency="' + freq + '">' +
              '<span>Co ' + freq + '</span>' +
              '<span>' + formatMoney(frequencyTotals[freq]) + '</span>' +
            '</div>';
          });

          newTotalsHTML += '</div></div>'; // Close tooltip and hint
        }

        newTotalsHTML += '<p class="cart-drawer__taxes-note">Koszty dostawy obliczane przy finalizacji</p>';

        totalsContainer.innerHTML = newTotalsHTML;
        DOM.totalEl = document.getElementById('cart-drawer-total');
      }

      // Update shipping progress using cached refs
      var remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - cart.total_price);
      var progressPercent = Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD) * 100);

      if (DOM.fillEl) {
        DOM.fillEl.style.width = progressPercent + '%';
        // PERFORMANCE: classList.toggle with condition
        DOM.fillEl.classList.toggle('cart-drawer__shipping-fill--success', remaining <= 0);
      }

      if (DOM.shippingTextEl) {
        DOM.shippingTextEl.innerHTML = remaining <= 0
          ? SVG.freeShipping + '<strong>Masz darmową wysyłkę!</strong>'
          : 'Brakuje <strong id="cart-drawer-remaining">' + formatMoney(remaining) + '</strong> do darmowej wysyłki';
      }

      // Update items or show empty state using cached refs
      if (cart.item_count === 0) {
        if (DOM.itemsContainer) DOM.itemsContainer.style.display = 'none';
        if (DOM.emptyEl) DOM.emptyEl.style.display = 'flex';
        if (DOM.footerEl) DOM.footerEl.style.display = 'none';
      } else {
        // PERFORMANCE: DocumentFragment for batch DOM insertion (single reflow)
        if (DOM.itemsContainer) {
          var fragment = document.createDocumentFragment();

          // Group one-time items by variant_id, keep subscription items as-is
          var processedVariants = {};
          var groupedItems = [];

          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            if (item.selling_plan_allocation) {
              // Subscription items are not grouped
              groupedItems.push({ item: item, index: i, grouped: false });
            } else {
              // One-time items - group by variant_id
              var variantId = item.variant_id;
              if (processedVariants[variantId]) {
                // Add to existing group
                var group = processedVariants[variantId];
                group.quantity += item.quantity;
                group.price += item.final_line_price;
                group.originalPrice += item.original_line_price;
                group.lineIndices.push(i + 1);
                group.keys.push(item.key);
              } else {
                // Create new group
                processedVariants[variantId] = {
                  item: item,
                  index: i,
                  quantity: item.quantity,
                  price: item.final_line_price,
                  originalPrice: item.original_line_price,
                  lineIndices: [i + 1],
                  keys: [item.key]
                };
                groupedItems.push({ variantId: variantId, grouped: true });
              }
            }
          }

          // Render grouped items
          groupedItems.forEach(function(entry) {
            if (entry.grouped) {
              var group = processedVariants[entry.variantId];
              fragment.appendChild(createGroupedItemElement(group));
            } else {
              fragment.appendChild(createItemElement(entry.item, entry.index));
            }
          });

          DOM.itemsContainer.innerHTML = '';
          DOM.itemsContainer.appendChild(fragment);
          DOM.itemsContainer.style.display = 'flex';
        }
        if (DOM.emptyEl) DOM.emptyEl.style.display = 'none';
        if (DOM.footerEl) DOM.footerEl.style.display = 'block';
      }

      // Update subscription tip visibility
      var subTipEl = document.getElementById('cart-drawer-sub-tip');
      if (subTipEl) {
        var hasSubscription = cart.items.some(function(item) {
          return item.selling_plan_allocation;
        });
        subTipEl.style.display = hasSubscription && !subTipEl.classList.contains('is-dismissed') ? 'flex' : 'none';
      }

      drawer.classList.remove('cart-drawer--loading');
    }

    // PERFORMANCE: Accept cart data directly to avoid extra fetch
    if (cartData) {
      doRefresh(cartData);
    } else {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(doRefresh)
        .catch(function(error) {
          console.error('Cart refresh error:', error);
          showErrorNotification('Nie udalo sie odswiezyc koszyka. Odswiez strone.');
          drawer.classList.remove('cart-drawer--loading');
        });
    }
  }

  // Helper: Format money (PLN)
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  // Helper: Polish plural for "sztuka"
  function formatSztuki(qty) {
    if (qty === 1) return 'sztuka';
    if (qty >= 2 && qty <= 4) return 'sztuki';
    return 'sztuk';
  }

  /**
   * SECURITY: Get sized image URL with validation.
   * Uses sanitizeImageUrl to ensure only Shopify CDN images are allowed.
   * @param {string} url - Original image URL
   * @param {string} size - Size suffix (e.g., '120x')
   * @returns {string} - Sized image URL or empty string
   */
  function getSizedImageUrl(url, size) {
    var safeUrl = sanitizeImageUrl(url);
    if (!safeUrl) return '';
    return safeUrl.replace(/(\.[^.]+)$/, '_' + size + '$1');
  }

  // PERFORMANCE: Escape HTML using cached element (no allocation per call)
  function escapeHtml(text) {
    escapeDiv.textContent = text || '';
    return escapeDiv.innerHTML;
  }

  /**
   * SECURITY: Sanitize URL to prevent XSS via javascript:, data:, and other dangerous protocols.
   * OWASP Reference: A03:2021 - Injection Prevention
   * @param {string} url - URL to sanitize
   * @returns {string} - Safe URL or empty string
   */
  function escapeUrl(url) {
    if (!url || typeof url !== 'string') return '';

    // Trim and remove null bytes/control characters
    var cleanUrl = url.trim().replace(/[\0\x00-\x1f]/g, '');
    if (!cleanUrl) return '';

    // Normalize for protocol checking (lowercase, no whitespace for protocol check)
    var normalizedUrl = cleanUrl.toLowerCase().replace(/\s/g, '');

    // Block dangerous protocols (javascript:, data:, vbscript:, file:, blob:)
    var dangerousProtocols = ['javascript:', 'data:', 'vbscript:', 'file:', 'blob:'];
    for (var i = 0; i < dangerousProtocols.length; i++) {
      if (normalizedUrl.indexOf(dangerousProtocols[i]) === 0) {
        return '';
      }
    }

    // Check URL-encoded variants
    try {
      var decodedUrl = decodeURIComponent(cleanUrl);
      var normalizedDecoded = decodedUrl.toLowerCase().replace(/\s/g, '');
      for (var j = 0; j < dangerousProtocols.length; j++) {
        if (normalizedDecoded.indexOf(dangerousProtocols[j]) === 0) {
          return '';
        }
      }
    } catch (e) {
      // Decoding failed - URL may be malformed
    }

    // Allow relative URLs (single leading slash only, not protocol-relative //)
    if (cleanUrl.charAt(0) === '/') {
      if (cleanUrl.charAt(1) === '/') {
        return ''; // Block protocol-relative URLs
      }
      return escapeHtml(cleanUrl);
    }

    // Allow only http and https for absolute URLs
    if (normalizedUrl.indexOf('http://') === 0 || normalizedUrl.indexOf('https://') === 0) {
      return escapeHtml(cleanUrl);
    }

    return '';
  }

  /**
   * SECURITY: Sanitize image URLs - allows only Shopify CDN and relative paths.
   * @param {string} url - Image URL to validate
   * @returns {string} - Safe URL or empty string
   */
  function sanitizeImageUrl(url) {
    if (!url || typeof url !== 'string') return '';

    var cleanUrl = url.trim();

    // Allow relative URLs (single slash)
    if (cleanUrl.charAt(0) === '/' && cleanUrl.charAt(1) !== '/') {
      return cleanUrl;
    }

    // Whitelist Shopify CDN domains only
    var lowercaseUrl = cleanUrl.toLowerCase();
    if (lowercaseUrl.indexOf('https://') === 0) {
      if (lowercaseUrl.indexOf('cdn.shopify.com') !== -1 ||
          lowercaseUrl.indexOf('.myshopify.com') !== -1) {
        return cleanUrl;
      }
    }

    return '';
  }

  // Calculate cart count: subscriptions count as bundles, regular items count as quantity
  function calculateCartCount(cart) {
    var count = 0;
    cart.items.forEach(function(item) {
      if (item.selling_plan_allocation) {
        var bundleSize = 1;
        if (item.properties && item.properties['_Bundle Size']) {
          bundleSize = parseInt(item.properties['_Bundle Size'], 10) || 1;
        }
        var subQty = Math.floor(item.quantity / bundleSize);
        if (subQty < 1) subQty = 1;
        count += subQty;
      } else {
        count += item.quantity;
      }
    });
    return count;
  }

  // PERFORMANCE: Cached header count elements
  var cachedCountEls = null;
  function updateCartCount(count) {
    if (!cachedCountEls) {
      cachedCountEls = document.querySelectorAll('.header__cart-count, .cart-drawer__count');
    }
    for (var i = 0; i < cachedCountEls.length; i++) {
      var el = cachedCountEls[i];
      if (el.classList.contains('header__cart-count')) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
        if (count > 0) {
          el.classList.add('header__cart-count--pulse');
        }
      } else {
        el.textContent = '(' + count + ')';
      }
    }
  }

  // Intercept add-to-cart forms
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.action && form.action.includes('/cart/add')) {
      e.preventDefault();

      const formData = new FormData(form);
      const quantityInput = form.querySelector('[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        return response.json().then(data => {
          // Check for error responses (status 422 or description indicates error)
          if (!response.ok || data.status === 422 || data.description) {
            var errorMsg = 'Nie udało się dodać produktu do koszyka.';
            var shopifyMsg = (data.description || data.message || '').toLowerCase();

            if (shopifyMsg) {
              // Check for quantity/availability limit errors - catch all variations
              if (shopifyMsg.includes('50') ||
                  shopifyMsg.includes('quantity') ||
                  shopifyMsg.includes('limit') ||
                  shopifyMsg.includes('tylko') ||
                  shopifyMsg.includes('pozycj') ||
                  shopifyMsg.includes('dodane') ||
                  shopifyMsg.includes('dostępn') ||
                  shopifyMsg.includes('dostepn') ||
                  shopifyMsg.includes('available') ||
                  shopifyMsg.includes('stock') ||
                  shopifyMsg.includes('inventory')) {
                errorMsg = 'Maksymalna ilość tego produktu to 50 sztuk.';
              }
            }
            throw new Error(errorMsg);
          }
          return data;
        });
      })
      .then(item => {
        // Show notification
        if (typeof window.showCartNotification === 'function') {
          window.showCartNotification(item.product_title || item.title, quantity);
        }

        // Dispatch custom event for analytics
        document.dispatchEvent(new CustomEvent('cart:added', {
          detail: {
            title: item.product_title || item.title,
            quantity: quantity,
            variant_id: item.variant_id,
            price: item.price
          }
        }));

        // Open drawer and refresh
        openCartDrawer();
        refreshDrawerContent();

        // Update count immediately
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => updateCartCount(calculateCartCount(cart)));
      })
      .catch(error => {
        console.error('Add to cart error:', error);
        showErrorNotification(error.message || 'Nie udało się dodać produktu do koszyka. Spróbuj ponownie.');
      });
    }
  });

  // Cart icon click opens drawer - use event delegation for reliability
  document.addEventListener('click', function(e) {
    const cartToggle = e.target.closest('.header__cart, [data-cart-toggle]');
    if (cartToggle) {
      e.preventDefault();
      openCartDrawer();
    }
  });
})();
